import http from '../../../httpRequests.js';

export default {
    state() {
        return {
            url: 'user/password/update',
        }
    },

    actions: {
        async updatePassword(context, payload) {
            const response = await http.put(context.state.url, context.rootState.lang, payload, context.rootState.token);
            return response;
        }
    },
}